import mainStyle from 'assets/css/main.module.scss'

import Content from './content/Content'
import styles from './PersistentPlatform.module.scss'
import { Flex } from '../common/flex/Flex'

interface Props {
  createMuralIsLoading: boolean
  muralData: any
  muralIsSuccess: boolean
}

const PersistentPlatform = ({ createMuralIsLoading, muralData, muralIsSuccess }: Props) => {
  return (
    <div
      data-testid="persistent-platform"
      className="bg-[#CBE8E6] lg2:mt-[272px] mb-16 tour-persistentplatform-framework"
    >
      <Flex gap={40} direction="column" className={styles.container}>
        <div className="w-full text-center lg2:-mt-16 mt-10">
          <h3 className={mainStyle.h3}>Persistent Platform Framework</h3>
        </div>
        <div className="w-full text-center -mt-4 mb-[10px]">
          <h5 className={styles.h5}>Ready to add in the new Persistent Product Edge?</h5>
        </div>
        <Content createMuralIsLoading={createMuralIsLoading} muralData={muralData} muralIsSuccess={muralIsSuccess} />
      </Flex>
    </div>
  )
}

export default PersistentPlatform
